const getRoleDefaultDisplayName = (role)=>role.role_id;

export { getRoleDefaultDisplayName };
//# sourceMappingURL=getRoleDefaultDisplayName.mjs.map
